module.exports = __webpack_public_path__ + "static/media/sensor-on.9d11060b.svg";